<template>
  <div>
    <Loading v-if="loading"/>
    <div v-if="isAuthenticated">
      <AppHeader/>

      <section class="main-menu navbar-space">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="secondary-title">
                <h5 class="title">ประวัติยืนยันการอนุมัติให้ใช้วงเงินและหักค่าธรรมเนียม</h5>
              </div>
            </div>
          </div>

          <div v-if="taskHistoryList.length > 0" class="row justify-content-center">
            <div class="col-12 col-xs-fix">
              <div class="purchase-table-wrapper table-wrapper">
                <table class="purchase-table table">
                  <thead>
                    <tr>
                      <!-- <th scope="col">เลือก</th> -->
                      <th scope="col">หมายเลขอ้างอิงรายการ</th>
                      <th scope="col">ประเภทธุรกรรม</th>    
                      <th scope="col">ประเภทการค้ำประกัน</th>
                      <th scope="col">สถานะ</th>
                      <th scope="col">วันที่ทำรายการ</th>
                      <th class="amt-th" scope="col">วงเงินค้ำประกัน(บาท)</th>
                      <th scope="col">ชื่อผู้รับผลประโยชน์</th>
                       <th scope="col">Tax Id ผู้ขอออก</th> 
                      <th scope="col">ชื่อผู้ขอออก</th>
                      <th scope="col">Tax Id ผู้ค้ำประกันในนาม</th>
                      <th scope="col">ชื่อผู้ค้ำประกันในนาม</th>
                      <th scope="col">หมายเลขบัญชีวงเงิน</th>
                      <!-- <th scope="col">สถานะ</th> -->
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr
                      class="main-row"
                      v-for="(item, index) in taskHistoryList"
                      v-bind:item="item"
                      v-bind:index="index"
                      v-bind:key="item.requestId"
                    >
                      <td class="name-cell" >
                        <a @click="getTaskHistoryDetail(item.requestId)"><font color="#008ec4"><u>{{item.requestId}}</u></font></a>
                      </td>
                      <td class="name-cell"  width="150%"> {{reqTypeMapping(item.reqType)}} </td>
                      <td class="name-cell"> <span v-html="item.contingentTypeNameTh"></span></td>
                      
                      <td class="status-cell">
                        <div v-if="item.status === 'AP'" class="status-wrapper status-success">
                          <span>{{item.statusDesc}}</span>
                        </div>
                        <div v-if="item.status === 'RJ'" class="status-wrapper status-danger">
                          <span>{{item.statusDesc}}</span>
                        </div>
                      </td>
                      <td class="date-cell">{{item.docCreateDate}}</td>
                      <td class="amt-cell">
                        <span class="amt-cur">{{formatPrice(item.lgAmt)}}</span>
                      </td>
                      <td class="name-cell">{{item.beneNameTh}}</td>
                       <td class="name-cell">{{item.requesterTaxId}}</td> 
                      <td class="name-cell">{{item.requesterNameTh}}</td>
                      <td class="name-cell">
                      <template  v-for="r in item.taskRequesterVoList">
                       {{ r.guaranteeTaxId}},
                      </template>
                      </td>
                      <td class="name-cell">
                      <template  v-for="r in item.taskRequesterVoList">
                       {{r.guaranteeName}},
                      </template>
                      </td>

                      <td class="name-cell">{{item.commNo}}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <b-pagination
              size="md"
              :total-rows="totalRecord"
              v-model="currentPage"
              :per-page="10"
              @input="getTaskHistoryList(currentPage)"
            ></b-pagination>
          </div>
          <div v-if="taskHistoryList.length === 0" class="row justify-content-center">
            <div class="col-12 col-xs-fix">
              <div class="purchase-table-wrapper table-wrapper">
                <table class="purchase-table table">
                  <thead>
                    <tr>
                      <!-- <th scope="col">เลือก</th> -->
                      <th scope="col">หมายเลขอ้างอิงรายการ</th>
                      <th scope="col">ประเภทรายการ</th>    
                      <th scope="col">ประเภทการค้ำประกัน</th>
                      <th scope="col">สถานะ</th>
                      <th scope="col">วันที่ทำรายการ</th>
                      <th class="amt-th" scope="col">จำนวนเงินค้ำประกัน(บาท)</th>
                      <th scope="col">ชื่อผู้รับผลประโยชน์</th>
                       <th scope="col">Tax Id ผู้ขอออก</th> 
                      <th scope="col">ชื่อผู้ขอออก</th>
                      <th scope="col">Tax Id ผู้ค้ำประกันในนาม</th>
                      <th scope="col">ชื่อผู้ค้ำประกันในนาม</th>
                      <th scope="col">หมายเลขบัญชีวงเงิน</th>
                      <!-- <th scope="col">สถานะ</th> -->
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="empty-data">
                      <td colspan="999">ไม่มีข้อมูล</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { mapGetters } from "vuex";
import { apiClient } from "@/utils/apiClient";

export default {
  components: {
    AppFooter,
    AppHeader
  },
  name: "TaskList",
  data() {
    return {
      taskHistoryList: [
        {
          taskId: "",
          requestId: ""
        }
      ],
      currentPage: 1,
      limitPage: 10,
      totalRecord: 0,
      taskVo: null
    };

  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return value === "" || value === undefined
        ? ""
        :val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    reqTypeMapping(tmpReqType) {
      let returnType = "";
      if (tmpReqType === "NEW") {
        returnType = "ออกหนังสือค้ำประกัน";
      } else if (tmpReqType === "INC") {
        returnType = "เพิ่มวงเงินหนังสือค้ำประกัน";
      } else if (tmpReqType === "EXT") {
        returnType = "ต่ออายุหนังสือค้ำประกัน";
      } else if (tmpReqType === "EXTINC") {
        returnType = "ต่ออายุ+เพิ่มวงเงิน";
      }

      return returnType;
    },
    getTaskHistoryList: function(currentPage) {
      this.loader = this.$loading.show();
      apiClient
        .get(
          "/api/task/getTaskHistoryList/" + currentPage + "/" + this.limitPage
        )
        .then(resp => {
          this.taskHistoryList = resp.data.list;
          this.totalRecord = resp.data.fullListSize;
          this.loader.hide();
          window.scrollTo(0, 0);
        })
        .catch(err => {
          if(err.response.status===401){
            this.loader.hide();
          }
        //  this.$swal("Error!", "" + err, "error");
        });
    },
    escapeHtml: function(unsafe) {
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
    },
    getTaskHistoryDetail: function(requestId) {
      this.loader = this.$loading.show();
      apiClient
        .get("/api/task/getTaskHistoryDetail/" + requestId)
        .then(resp => {
          let taskVo = resp.data;
          var periodDateStr = "";

          if (taskVo.periodEndDate.length > 0) {
            periodDateStr = taskVo.periodStartDate +" ถึง " +taskVo.periodEndDate;
          } else {
            periodDateStr = taskVo.periodStartDate;
          }

          var strRequest = "";
          if (
            taskVo.taskRequesterVoList != null &&
            taskVo.taskRequesterVoList.length > 0
          ) {
            for (var i = 0; i < taskVo.taskRequesterVoList.length; i++) {
              strRequest =
                strRequest +
                taskVo.taskRequesterVoList[i].guaranteeTaxId +
                " : " +
                taskVo.taskRequesterVoList[i].guaranteeName +
                "<br/>";
            }
          }
          var reqTypeStr =  this.reqTypeMapping(taskVo.reqType);

          var strStamp = "";
          if(taskVo.reqType === "NEW"){
            strStamp = "15.00";
          }

          var approveCifDiv = '';
          if(taskVo.approveByCifName != ''){
            approveCifDiv = 
            "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ผู้" + this.escapeHtml(taskVo.statusDesc) + "</label>" +
              "   </div>" +
              "   <div class='text-sum col-md-7'>" +
                    this.escapeHtml(taskVo.approveByCifName) +
              "   </div>" +
              "</div>";
          }

          this.$swal.fire({
            title:
              "<h4><b>รายละเอียดการอนุมัติให้ใช้วงเงินและหักค่าธรรมเนียม</b></h4>",
            width: 600,
            html:
              "<div class='card-body compact-padding'>" +
              "   <div class='default-padding'>" +
              "      <div class='form-row'>" +
              "         <div class='form-group-sum col-md-5'>" +
              "            <label>หมายเลขอ้างอิงรายการ</label>" +
              "       </div>" +
              "      <div class='text-sum col-md-7'>" +
              this.escapeHtml(taskVo.requestId) +
              "    </div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ประเภทธุรกรรม</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              this.escapeHtml(reqTypeStr) +
              " </div>" +
              " </div>" +
              " <div class='form-row'>" +
              "    <div class='form-group-sum col-md-5'>" +
              "       <label>ผู้ขอออกหนังสือค้ำประกัน</label>" +
              "  </div>" +
              " <div class='text-sum col-md-7 name-cell'>" +
              this.escapeHtml(taskVo.requesterTaxId) +
              " " +
              this.escapeHtml(taskVo.requesterNameTh) +
              "</div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>สถานะ</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              this.escapeHtml(taskVo.statusDesc) +
              "</div>" +
              " </div>"+ 
              approveCifDiv +              
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ผู้รับผลประโยชน์</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              this.escapeHtml(taskVo.beneTaxId) +
              " " +
              this.escapeHtml(taskVo.beneNameTh) +
              "</div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ประเภทการค้ำประกัน</label>" +
              " </div>" +
              " <div class='text-sum col-md-7'>" +
              this.escapeHtml(taskVo.contingentTypeNameTh) +
              "</div>" +
              " </div>" +
              " <div class='form-row'>" +
              "    <div class='form-group-sum col-md-5'>" +
              "       <label>เพื่อค้ำประกันในนาม</label>" +
              "  </div>" +
              " <div class='text-sum col-md-7'>" +
              strRequest +
              "</div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>จำนวนเงินค้ำประกัน (บาท)</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              this.formatPrice(taskVo.lgAmt) +
              " </div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>มีผลบังคับใช้ตั้งแต่วันที่</label>" +
              " </div>" +
              " <div class='text-sum col-md-7'>" +
              this.escapeHtml(periodDateStr) +
              " </div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>วันที่ทำรายการ</label>" +
              " </div>" +
              " <div class='text-sum col-md-7'>" +
              this.escapeHtml(taskVo.docCreateDate) +
              " </div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>หมายเลขบัญชีวงเงิน</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              this.escapeHtml(taskVo.commNo) +
              "      </div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ชื่อบัญชีวงเงิน</label>" +
              " </div>" +
              " <div class='text-sum col-md-7'>" +
              this.escapeHtml(taskVo.commName) +
              "</div>" +
              " </div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>บัญชีหักค่าธรรมเนียม</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              this.escapeHtml(taskVo.accNoFee) +
              " - " +
              this.escapeHtml(taskVo.accNameFee) +
              "</div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ค่าธรรมเนียม (บาท)</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              "ค่าธรรมเนียมขั้นต่ำ 500 บาท หรือเป็นไปตามระเบียบธนาคาร" +
              "</div>" +
              "</div>" +
              "<div class='form-row'>" +
              "   <div class='form-group-sum col-md-5'>" +
              "      <label>ค่าอากรแสตมป์ (บาท)</label>" +
              " </div>" +
              "<div class='text-sum col-md-7'>" +
              strStamp +
              "</div>" +
              "</div>",

            //type: 'warning',
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "ปิดรายละเอียด"
          });

          this.loader.hide();
        })
        .catch(err => {
          this.loader.hide();
          this.$swal("Error!", "" + err, "error");
        });
    }
  },

  mounted() {
    this.getTaskHistoryList(this.currentPage);
  }
};
</script>